module.exports = __webpack_public_path__ + "static/media/75.8bdbce45.png";